
import createRandomString from '../../../libs/utils/createRandomString'

const LENGTH_FILE_TRANSFER_ID = 12;
const createFileTransferExtraParams = ({ chash, fileTransferSessionId, nickname, connectionId, clientTimestamp }) => {
  const fileTransferId = createRandomString(LENGTH_FILE_TRANSFER_ID);
  const cmdUrl = window.room_cmdUrl || `https://cw5i.${window.subdomainsExceptFirst}`;
  // window.room_cmdUrl
  const ftUrl = `${cmdUrl}/file-transfer/upload/${chash}/${fileTransferSessionId
  }?ftid=${fileTransferId}&connectionId=${connectionId}&clientTimestamp=${clientTimestamp}`;
  const fileUploadUrl = ftUrl;

  return {
    actionUrl: fileUploadUrl,
    nickname,
    progressSubmitParams: {
      chash,
      fileTransferId,
      fileTransferSessionId,
      cmdUrl,
    },
  };
};

export default createFileTransferExtraParams;
